import React, { FC, useState, useEffect } from 'react';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { Transaction, PublicKey, SystemProgram } from '@solana/web3.js';
import axios from 'axios';
import { config } from '../config';
import loadingUrl from "../images/loading.gif";
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root');


export const Presale: FC = () => {

    const [original, setOriginal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [amount, setAmount] = useState(1);
    const [stakeAmount, setStakeAmount] = useState(1 * 1000000000);

    const onAmountChange = (e: any) => {

        setAmount(parseInt(e.target.value));
        setStakeAmount(parseInt(e.target.value) * 1000000000);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    const openModal = () => {
        setIsOpen(true);
    }

    const { connection } = useConnection();
    const { publicKey, sendTransaction, signTransaction } = useWallet();

    const doStake = (hash: string, stakeAmount: number) => {


        if (!publicKey) throw new WalletNotConnectedError();

        setLoading(true);

        const data = {
            address: publicKey?.toString(),
            amount: stakeAmount
        }
        axios.post(`${config.url}/stake/buy`, data).then(() => {
            getData(publicKey?.toString())
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });

    }



    const onClick = async () => {

        setIsOpen(false);

        try {

            if (!publicKey || !signTransaction) throw new WalletNotConnectedError();

            const recipientAddress = new PublicKey(config.contract);

            const transaction = new Transaction().add(
                SystemProgram.transfer({
                    fromPubkey: publicKey,
                    toPubkey: recipientAddress,
                    lamports: stakeAmount,
                })
            );
    
            const {
                context: { slot: minContextSlot },
                value: { blockhash, lastValidBlockHeight }
            } = await connection.getLatestBlockhashAndContext();
    
            const signature = await sendTransaction(transaction, connection, { minContextSlot });
    
            await connection.confirmTransaction({ blockhash, lastValidBlockHeight, signature });

            console.log(signature);

            doStake(signature, stakeAmount);

        } catch (err) {
            console.log(err);
        }

    };

    const getData = (address: string) => {

        axios.get(`${config.url}/stake/buys?address=${address}`)
            .then(response => {
                const data = response.data;
                setOriginal(data.amount / 1000000000);
            });
    }

    useEffect(() => {

        if (publicKey) {
            getData(publicKey.toString());
        }

    }, [publicKey])

    return (
        <div className="main__article">
            <h1 className="onerow"><div><span>PRESALE &nbsp</span></div><div><span>DASHBOARD</span></div></h1>
            <div className="dashboard__body">
                <div className="db__top">
                    <div className="db__item">
                        <div className="dbi__inner">
                            <div className="dbi__header">
                                <div className="dbi__label">My presale balance</div>
                            </div>
                            <div className="dbi__balance">
                                <div className="dbib__name">$SOL</div>
                                <div className="dbib__sum"><span className="dbis__top">{original}</span></div>
                            </div>
                            <div className="dbi__bottom stackButtons">
                                <button disabled={loading} id="stake" className="check full" onClick={openModal}>Buy</button>
                            </div>
                        </div>
                    </div>

                    {
                        loading &&
                        <div className="loading">
                            <img src={loadingUrl}></img>
                        </div>
                    }
                    <Modal
                        isOpen={modalIsOpen}
                        style={customStyles}
                        contentLabel="Example Modal"
                        onRequestClose={closeModal}
                    >
                        <div className="modal">
                            <h5>Amount of staking</h5>
                            <input type="number" value={amount} onChange={onAmountChange}></input>
                            <div className='buttons'>
                                <button onClick={onClick} className="tr-ok">ok</button>
                                <button onClick={closeModal} className="tr-cancel">cancel</button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>

    )
}

export default Presale;